import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  jobId: null,
  data: null,
  images: [],
};

export const listingSlice = createSlice({
  name: 'listing',
  initialState,
  reducers: {
    setListingJobId: (state, action) => {
      state.jobId = action.payload;
    },
    setListingData: (state, action) => {
      state.data = action.payload;
    },
    setListingImages: (state, action) => {
      state.images = action.payload;
    },
    resetListing: () => initialState,
  },
});

export const { resetListing, setListingJobId, setListingData, setListingImages } = listingSlice.actions;

export default listingSlice.reducer;
